import { createSelector } from 'reselect';
import { WorkflowsRootState } from '../ducks.types';

export const getTakeovers = (state: WorkflowsRootState) => state.workflow?.takeovers || {};

export const selectOpenTakeovers = createSelector([getTakeovers], (takeovers) =>
  Object.entries(takeovers),
);
